import type { LineItemBuilder } from "../../../../../utils/cartUpdating/LineItemUpdate";
import { convertProductToImpressionCart, trackCartChange } from "~/app/analytics/ga/ga";
import type { RootState } from "~/app/store";
import { groupByFn } from "~/common/utils/reducers";
import { selectProductDescriptor } from "~/domains/product/redux/selectors";
import { getPricePerPiece } from "~/domains/product/utils/productDescriptorUtils";
import type { ProductDescriptor } from "~/domains/product/types/ProductDescriptor";

export function getDesciptorsForLineItems(state: RootState, productCode: string, lineItems: LineItemBuilder[]) {
  const priceReferences = Object.keys(groupByFn(lineItems, (item) => item.get("priceReference")));
  return priceReferences.reduce((map, priceReference) => {
    map[priceReference] = selectProductDescriptor(state, {
      productCode,
      priceReference,
    });
    return map;
  }, {} as Dict<ProductDescriptor>);
}

export function trackCartUpdate(editedLineItem: LineItemBuilder, productDescriptor: ProductDescriptor) {
  if (!editedLineItem.hasUpdatesForSending()) {
    return;
  }
  const { base, availability } = productDescriptor;

  const oldLineItem = editedLineItem.getOriginal();
  const oldImpression = convertProductToImpressionCart(base, oldLineItem, availability, getPricePerPiece(oldLineItem));

  const newLineItem = editedLineItem.buildForSending()!;
  const newImpression = convertProductToImpressionCart(base, newLineItem, availability, getPricePerPiece(newLineItem));
  trackCartChange(oldImpression, newImpression);
}
